module.exports = __webpack_public_path__ + "img/ignis-glx-constelacion.86112bed.png";